import { Pipe, PipeTransform } from '@angular/core';
import { OrganizationMemberFlags } from '@ui/products/product-editor/graphql';
import { Observable } from 'rxjs';
import { OrganizationDetailsService } from 'ZalamoLibrary/src/lib/core/organizations/organization-details.service';
import { map, startWith, tap } from 'rxjs/operators';

@Pipe({
    name: 'hideFromOrganizationMember',
    standalone: false
})
export class HideFromOrganizationMemberPipe implements PipeTransform {
  constructor(private organizationDetailsService: OrganizationDetailsService) {}

  transform(
    value: keyof Omit<OrganizationMemberFlags, '__typename'>,
  ): Observable<boolean> {
    return this.organizationDetailsService.flags$.pipe(
      map((flags) =>
        typeof flags?.[value] === 'undefined' ? false : flags?.[value],
      ),
      startWith(false),
    );
  }
}
